<script>
import axios from "axios";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import _ from "lodash";

export default {
  components: { Datatable, Pagination },
  props: {
    idJadwal: { type: [String, Number], required: true },
    namaBatch: { type: [String, Number], required: true },
  },
  data() {
    return {
      isLoading: false,
      column: [
        { label: "NIP", name: "nip" },
        { label: "Nama", name: "nama" },
        { label: "Progress Pengerjaan", name: "progress_pengerjaan" },
        { label: "Persentase", name: "persentase" },
      ],
      pagination: {},
      tableFilter: {
        page: 1,
        per_page: 10,
        nip: "",
        nama: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getData();
    this.filterData = _.debounce(this.getData.bind(this), 500);
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const authToken = localStorage.access_token;
        const encodedNamaBatch = encodeURIComponent(this.namaBatch);
        const url = `${process.env.VUE_APP_BACKEND_URL_VERSION}master/jadwal-pelaksanaan/progress-batch/${this.idJadwal}/detail/${encodedNamaBatch}`;
        
        const response = await axios.get(url, {
          params: this.tableFilter,
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const data = response.data.data;
        this.tableData = data.data;
        this.pagination = data;
      } catch (error) {
        console.error("Error fetching detail progress:", error);
      } finally {
        this.isLoading = false;
      }
    },
    toPage(url) {
      if (url) {
        let link = new URLSearchParams(url.split("?")[1]);
        this.tableFilter.page = link.get("page");
        this.getData();
      }
    },
  },
};
</script>

<template>
  <div>
    <h5>Detail Progress Batch: {{ namaBatch }}</h5>
    <hr />
    <div class="row mb-3">
      <div class="form-group col-md-6">
        <label>Filter NIP</label>
        <input
          type="text"
          class="form-control"
          placeholder="Cari NIP"
          v-model="tableFilter.nip"
          @input="filterData"
        />
      </div>
      <div class="form-group col-md-6">
        <label>Filter Nama</label>
        <input
          type="text"
          class="form-control"
          placeholder="Cari Nama"
          v-model="tableFilter.nama"
          @input="filterData"
        />
      </div>
    </div>
    
    <table class="mb-2">
      <tr>
        <td>Show</td>
        <td>
          <select
            class="form-control form-control-sm"
            v-model="tableFilter.per_page"
            @change="getData()"
          >
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </td>
        <td>Entries</td>
      </tr>
    </table>

    <Datatable :columns="column">
      <tbody>
        <tr v-if="isLoading">
          <td colspan="4" class="text-center">
            <i class="fa fa-spinner fa-spin"></i> Loading...
          </td>
        </tr>
        <tr v-else-if="!tableData.length">
          <td colspan="4" class="text-center">Data tidak ditemukan</td>
        </tr>
        <tr v-else v-for="row in tableData" :key="row.nip">
          <td>{{ row.nip }}</td>
          <td>{{ row.nama }}</td>
          <td>{{ row.progress_pengerjaan }}</td>
          <td>{{ row.persentase }}</td>
        </tr>
      </tbody>
    </Datatable>
    <pagination :pagination="pagination" @to-page="toPage"></pagination>
  </div>
</template>